import React, {useRef, useEffect, useState} from 'react';
import CalendrierInfoReservation from "./calendrier-info-reservation";
import Guid from '../../models/Guid';
import ChoixUniteCarte from './calendrier-carteTemp';
import CalendrierReservationEntete from './calendrier-reservation-entete';
import {ContextMenu, ContextMenuRef} from "devextreme-react/context-menu";
import CalendrierReservations from "./calendrier-reservations";
import IReservationCalendrier from "../../models/IReservationCalendrier";
import CalendrierEntete from "./calendrier-entete";
import CalendrierGridRows from "./calendrier-grid-rows";
import {ISelectedCells} from './calendrier-interfaces';

interface CalendrierGridProps {
    idReservationEntete: Guid | undefined;
    isCarte: boolean,
    handleKeyDown: any,
    calendrierData: IReservationCalendrier[] | undefined;
    selectedTypeUniteId: Guid,
    selectedCell: ISelectedCells[],
    navigateCalendrier: any
    contextMenuRef: React.RefObject<ContextMenuRef<any>>
    contextMenuOpened: boolean,
    setContextMenuOpened: React.Dispatch<React.SetStateAction<boolean>>
}

const CalendrierGrid = ({idReservationEntete, isCarte, handleKeyDown, calendrierData, selectedTypeUniteId, selectedCell, navigateCalendrier, contextMenuRef, contextMenuOpened, setContextMenuOpened}: CalendrierGridProps) => {
    const gridRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const ele = gridRef?.current;
        if (!ele) return;
        const f = (event: any) => {
            if (contextMenuOpened) {
                contextMenuRef.current?.instance().hide();
            }
        }
        ele?.addEventListener("mousedown", f);
        return () => ele?.removeEventListener("mousedown", f);
    }, [contextMenuRef, gridRef, contextMenuOpened]);

    return (
        <div className="calendrier-container">
            <button style={{width: "3rem"}} onClick={() => navigateCalendrier(-1)}>{"<"}</button>
            <div style={{flex: 1, overflow: "hidden"}}>
                <div ref={gridRef}
                     onKeyDown={handleKeyDown}
                     style={{flex: 1, position: "relative", maxHeight: `calc(100vh - ${idReservationEntete ? 11.8 : 2.5}rem - 165px )`}} id={"calendrier-grid"} className="calendrier-grid">
                    {!isCarte && <CalendrierEntete key={`calendrier-entete-${(selectedTypeUniteId || Guid.empty).toString()}`} selectedCell={selectedCell}/>}
                    <CalendrierGridRows key={`calendrier-grid-rows-${(selectedTypeUniteId || Guid.empty).toString()}`} selectedCells={selectedCell}/>
                    <CalendrierReservations data={calendrierData || []}/>
                </div>
                {isCarte ?
                    <ChoixUniteCarte
                        unites={[]}
                        gotoChoixUnite={() => {
                        }}
                        location={{search: 'test'}}
                        src='data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'
                    /> : null
                }
                {idReservationEntete && <CalendrierReservationEntete idReservationEntete={idReservationEntete}/>}
            </div>
            <button style={{width: "3rem"}} onClick={() => navigateCalendrier(1)}>{">"}</button>

            {/* <ContextMenu ref={contextMenuRef} target={"#calendrier-grid"} items={contextMenuitems} onItemClick={onContextMenuItemClick} hoverStateEnabled={true} onShown={onContextMenuShown} onHidden={onContextMenuHidden} /> */}
        </div>
    )
}
export default CalendrierGrid;